import { render } from "./Management.vue?vue&type=template&id=42b74236"
import script from "./Management.vue?vue&type=script&lang=js"
export * from "./Management.vue?vue&type=script&lang=js"

import exportComponent from "D:\\software\\jenkins_home\\.jenkins\\workspace\\dev\\vls\\html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__